import { render, staticRenderFns } from "./MaturityGovernmentPage.vue?vue&type=template&id=28b1fcbc&scoped=true"
import script from "./MaturityGovernmentPage.vue?vue&type=script&lang=js"
export * from "./MaturityGovernmentPage.vue?vue&type=script&lang=js"
import style0 from "./MaturityGovernmentPage.vue?vue&type=style&index=0&id=28b1fcbc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1fcbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b1fcbc')) {
      api.createRecord('28b1fcbc', component.options)
    } else {
      api.reload('28b1fcbc', component.options)
    }
    module.hot.accept("./MaturityGovernmentPage.vue?vue&type=template&id=28b1fcbc&scoped=true", function () {
      api.rerender('28b1fcbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/MaturityGovernmentPage.vue"
export default component.exports